

import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../App.css";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { getCurrencies, toggleCurrencyStatus, deleteCurrency, addCurrency, updateCurrency, setBaseCurrency, togglenabledCurrencyStatus } from "../../services/reactapis";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate, useLocation } from "react-router-dom";
import { ApiUrl } from '../../Constants/Weburl'
import CustomTable from "../../components/CustomTable";
import CustomButton from "../../components/CustomButton";
import CustomSwitch from "../../components/Customswitch";
import CustomPagination from '../../components/Custompagination'
import CustomContainer from "../../components/Customsettingscontain";
import CustomInput from '../../components/Custominput';
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import DeleteModal from "../../components/DeleteModal";
import Layout from "../../components/Layout";
import useExpandableRows from "../../components/useExpandableRows";
import useHiddenColumns from "../../components/useHiddenFields";

export default function CurrencyGrid() {
    const [totalPages, setTotalPages] = useState(1);

    const [totalEntries, setTotalEntries] = useState(0);


    const [currencies, setCurrencies] = useState([]);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(true);


    //add currency state
    const [countryName, setCountryName] = useState("");
    const [currencyCode, setCurrencyCode] = useState("");
    const [currencySymbol, setCurrencySymbol] = useState("");
    const [isEnabled, setIsEnabled] = useState(false);


    //delete modal 
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteTag, setDeleteTag] = useState("");

    //edit currency state
    const [editId, setEditId] = useState(null);

    //modal
    const [showModal, setShowModal] = useState(false);


    const navigate = useNavigate();
    const location = useLocation();

    const currentUser = JSON.parse(localStorage.getItem("currentUser"));

    const adminToken = localStorage.getItem("adminToken");


    // const headers = [
    //     "",
    //     "Country Name",
    //     "Country Code",
    //     "Country Symbol",
    //     "Status",
    //     "Base Currency",
    //     "Action",
    // ];
    const headers = [
        { label: "", className: "cg-col-select" },
        { label: "Country Name", className: "cg-col-name" },
        { label: "Country Code", className: "cg-col-code", field: "code" },
        { label: "Country Symbol", className: "cg-col-symbol", field: "symbol" },
        { label: "Status", className: "cg-col-status", field: "status" },
        { label: "Base Currency", className: "cg-col-base", field: "base" },
        { label: "Action", className: "cg-col-action", field: "action" },
    ];

    const { toggleExpand, isExpanded } = useExpandableRows();
    const hiddenFields = useHiddenColumns(".rr1-table", headers);

    useEffect(() => {
        fetchData();
    }, [search, page]);


    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const searchParam = params.get("search");

        if (searchParam) {

            const cleaned = searchParam.replace(/\s*\([^)]*\)\s*$/, "").trim();
            setSearch(cleaned);
            setPage(1);
        }
    }, [location.search]);

    //   const fetchData = async () => {
    //     setLoading(true);
    //     try {
    //       const res = await getCurrencies(search, page, 10 , adminToken);

    //       setCurrencies(res.data);
    //        console.log('fetchdata' , res.data)
    //     } catch (err) {
    //       console.error('Failed to fetch currencies', err);
    //     } finally {
    //       setLoading(false);
    //     }
    //   };


    const fetchData = async () => {
        setLoading(true);

        try {
            const res = await getCurrencies(
                search,
                page,
                10,
                adminToken
            );

            console.log("fetchdata", res);

            setCurrencies(res.data || []);
            setTotalPages(res.pagination?.totalPages || 1);
            setTotalEntries(res.pagination?.total || 0);

        } catch (err) {
            console.error("Failed to fetch currencies", err);

            setCurrencies([]);
            setTotalPages(1);
            setTotalEntries(0);
        } finally {
            setLoading(false);
        }
    };


    const handleToggle = async (id) => {
        try {
            await togglenabledCurrencyStatus(id, adminToken);
            fetchData(); // refresh list after toggle
        } catch (err) {
            console.error('Toggle failed', err);
        }
    };

    // const handleDelete = async (id) => {
    //     try {
    //        const res = await deleteCurrency(id, adminToken);
    //         if (res.data.success) {
    //             fetchData();
    //             setShowDeleteModal(false);
    //             setDeleteId(null);
    //         }
    //         else {
    //             alert("Delete Failed")
    //         }


    //     } catch (err) {
    //         console.error('Delete failed', err);
    //     }
    // };

    // const handleAdd = async (formData) => {
    //     try {
    //         await addCurrency(formData); // { name, code, symbol }
    //         fetchData();
    //     } catch (err) {
    //         console.error('Add failed', err);
    //     }
    // };

    const handleDelete = async () => {
        if (!deleteId) return;

        try {
            const res = await deleteCurrency(deleteId, adminToken);

            console.log("Delete response:", res);

            if (res.success) {
                await fetchData();

                setShowDeleteModal(false);
                setDeleteId(null);
                setDeleteTag("");
            } else {
                alert(res.message || "Delete Failed");
            }
        } catch (err) {
            console.error("Delete error:", err);

            alert(
                err.response?.data?.message ||
                err.message ||
                "Failed to delete currency"
            );
        }
    };

    const handleAdd = async () => {
        try {
            const currencyData = {
                name: countryName,
                code: currencyCode,
                symbol: currencySymbol,
                is_enabled: isEnabled,
            };

            await addCurrency(currencyData, adminToken);

            setShowModal(false);

            setCountryName("");
            setCurrencyCode("");
            setCurrencySymbol("");
            setIsEnabled(true);

            fetchData();

        } catch (err) {
            console.error("Add currency failed", err);
        }
    };


    //handleedit
    const handleEdit = (currency) => {
        setEditId(currency.id);

        setCountryName(currency.name || "");
        setCurrencyCode(currency.code || "");
        setCurrencySymbol(currency.symbol || "");
        setIsEnabled(Boolean(currency.is_enabled));

        setShowModal(true);
    };


    //update api 
    const handleUpdate = async () => {
        try {
            const currencyData = {
                name: countryName,
                code: currencyCode,
                symbol: currencySymbol,
                is_enabled: isEnabled,
            };

            await updateCurrency(
                editId,
                currencyData,
                adminToken
            );

            setShowModal(false);

            // Clear
            setEditId(null);
            setCountryName("");
            setCurrencyCode("");
            setCurrencySymbol("");
            setIsEnabled(true);

            fetchData();

        } catch (err) {
            console.error("Update currency failed", err);
        }
    };


    const handleSelectCurrency = async (id) => {
        try {
            await toggleCurrencyStatus(id, adminToken);
            fetchData();
        } catch (err) {
            console.error("Currency selection failed", err);
        }
    };




    const handleSetBase = async (id) => {
        try {
            await setBaseCurrency(id, adminToken);
            fetchData(); // refresh — other rows' is_base auto becomes false
        } catch (err) {
            console.error("Set base currency failed", err);
        }
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;

        setSearch(value);
        setPage(1);

        const params = new URLSearchParams(location.search);

        if (value.trim()) {
            params.set("search", value);
        } else {
            params.delete("search");
        }

        navigate(
            `${location.pathname}?${params.toString()}`,
            { replace: true }
        );
    };


    return (
        <div className="layout">
            <Layout>

                {loading ? (
                    <div className="rr-wrapperhashtag">
                        <p>Loading...</p>
                    </div>
                ) : (
                    <CustomContainer className="rr-wrapperhashtag" fluid="false">
                        <div className="ht-header-bar">
                            <h3 className="ht-page-title">CURRENCIES</h3>
                            <CustomButton
                                className="rr-add-btnhashtag ht-add-btn"
                                // onClick={saveSettings}
                                // disabled={saving}
                                // onClick={() => setShowModal(true)}
                                onClick={() => {
                                    setEditId(null);
                                    setCountryName("");
                                    setCurrencyCode("");
                                    setCurrencySymbol("");
                                    setIsEnabled(true);
                                    setShowModal(true);
                                }}
                            >
                                Add Currency
                                {/* {saving ? "Saving..." : saved ? "Saved!" : "Save"} */}
                            </CustomButton>




                            <div className="ht-header-right">
                                <div className="rr-left">
                                    Show
                                    <select
                                        className="rr-select"
                                    // value={limit}
                                    // onChange={(e) => {
                                    //     setLimit(Number(e.target.value));
                                    //     setPage(1);
                                    // }}
                                    >
                                        <option>5</option>
                                        <option>10</option>
                                        <option>25</option>
                                        <option>50</option>
                                    </select>
                                    entries
                                </div>

                                <div className="rr-right">
                                    <span>Search:</span>
                                    <CustomInput
                                        className="rr-search"
                                        type="text"
                                        value={search}
                                        onChange={handleSearchChange}
                                        placeholder="Search Users"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="rr-card">
                            <CustomTable headers={headers} className="rr1-table">
                                {loading ? (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center", padding: 20 }}>
                                            Loading...
                                        </td>
                                    </tr>
                                ) : currencies?.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center", padding: 20 }}>
                                            {search ? `No users found matching "${search}"` : "No users found"}
                                        </td>
                                    </tr>
                                ) : (
                                    currencies.map((u) => (
                                        <React.Fragment key={u.id}>
                                            <tr>
                                                <td className="cg-col-select" style={{ display: 'flex', alignItems: 'center' }}>
                                                    {hiddenFields.length > 0 && (
                                                        <button
                                                            type="button"
                                                            className={`row-expand-toggle ${isExpanded(u.id) ? "is-open" : ""}`}
                                                            onClick={() => toggleExpand(u.id)}
                                                            aria-label="Show more details"
                                                        >
                                                            {isExpanded(u.id) ? "−" : "+"}
                                                        </button>
                                                    )}
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={Boolean(u.is_selected)}
                                                        onChange={() => handleSelectCurrency(u.id)}
                                                    />
                                                </td>
                                                <td className="cg-col-name">
                                                    <div>
                                                        <div className="username">{u.name || ""}</div>
                                                    </div>
                                                    {/* </div> */}
                                                </td>
                                                <td className="cg-col-code">
                                                    <span className="real-badge">{u.code || ""}</span>
                                                </td>
                                                <td className="username cg-col-symbol">{u.symbol}</td>
                                                <td className="cg-col-status">
                                                    <CustomSwitch
                                                        checked={Boolean(u.is_enabled)}
                                                        onChange={() => handleToggle(u.id)}

                                                    // onChange={() => handleFreeze(u.id)}
                                                    />
                                                </td>

                                                <td className="cg-col-base" style={{ textAlign: 'center' }}>
                                                    <Form.Check
                                                        type="checkbox"
                                                        name="baseCurrency"
                                                        checked={Boolean(u.is_base)}
                                                        onChange={() => handleSetBase(u.id)}
                                                        // disabled={!u.is_enabled} 
                                                        disabled={!u.is_enabled || !u.is_selected}
                                                    />
                                                </td>

                                                <td>
                                                    <td className="rr-actions cg-col-action">
                                                        <CustomButton
                                                            reportclassName="rr-icon-btn green"
                                                            onClick={() => handleEdit(u)}
                                                        //  onClick={() => editReason(item)}
                                                        >
                                                            <i className="bi bi-pencil"></i>
                                                        </CustomButton>

                                                        <CustomButton
                                                            reportclassName="rr-icon-btn red"
                                                            //  onClick={() => deleteReason(item.id)} 
                                                            // onClick={() => handleDelete(u.id)}
                                                            onClick={() => {
                                                                setDeleteId(u.id);
                                                                setDeleteTag(u.name);
                                                                setShowDeleteModal(true);
                                                            }}
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </CustomButton>
                                                    </td>
                                                </td>
                                            </tr>

                                            {isExpanded(u.id) && hiddenFields.length > 0 && (
                                                <tr className="row-expand-details">
                                                    <td colSpan={7}>
                                                        <div className="expand-details">
                                                            {hiddenFields.map(({ field, label }) => (
                                                                <div className="expand-item" key={field}>
                                                                    <span className="expand-label">{label}</span>

                                                                    {field === "code" && (
                                                                        <span className="real-badge">{u.code || ""}</span>
                                                                    )}

                                                                    {field === "symbol" && (
                                                                        <span className="expand-value">{u.symbol}</span>
                                                                    )}

                                                                    {field === "status" && (
                                                                        <CustomSwitch
                                                                            checked={Boolean(u.is_enabled)}
                                                                            onChange={() => handleToggle(u.id)}
                                                                        />
                                                                    )}

                                                                    {field === "base" && (
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            name="baseCurrency"
                                                                            checked={Boolean(u.is_base)}
                                                                            onChange={() => handleSetBase(u.id)}
                                                                            disabled={!u.is_enabled || !u.is_selected}
                                                                        />
                                                                    )}

                                                                    {field === "action" && (
                                                                        <div style={{ display: "flex", gap: 8 }}>
                                                                            <CustomButton reportclassName="rr-icon-btn green" onClick={() => handleEdit(u)}>
                                                                                <i className="bi bi-pencil"></i>
                                                                            </CustomButton>
                                                                            <CustomButton
                                                                                reportclassName="rr-icon-btn red"
                                                                                onClick={() => {
                                                                                    setDeleteId(u.id);
                                                                                    setDeleteTag(u.name);
                                                                                    setShowDeleteModal(true);
                                                                                }}
                                                                            >
                                                                                <i className="bi bi-trash"></i>
                                                                            </CustomButton>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))
                                )}
                            </CustomTable>





                            <div className="rr-footer">

                                <>
                                    {/* <span>
                                    Showing {currencies.length > 0 ? 1 : 0} to {currencies.length} of {currencies.length} entries
                                </span> */}

                                    <span>
                                        Showing{" "}
                                        {currencies.length > 0 ? ((page - 1) * 10) + 1 : 0}
                                        {" "}to{" "}
                                        {Math.min(page * 10, totalEntries)}
                                        {" "}of{" "}
                                        {totalEntries} entries
                                    </span>
                                    <CustomPagination
                                        currentPage={page}
                                        totalPages={totalPages}
                                        // onPageChange={(page) => setPage(page)}
                                        onPageChange={(newPage) => setPage(newPage)}
                                        className="rr-pagination"
                                        pageClassName="rr-page"
                                        activeClassName="active"
                                        ellipsisClassName="rr-page"
                                    />
                                </>



                            </div>
                        </div>
                    </CustomContainer>
                )}
            </Layout>


            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                className="hashtag-add-modal"
            >
                <Modal.Header className="hashtag-modal-header">
                    <Modal.Title>
                        {/* Add Currency */}
                        {editId ? "Edit Currency" : "Add Currency"}
                    </Modal.Title>

                    <CustomButton
                        type="button"
                        className="hashtag-close-btn"
                        onClick={() => setShowModal(false)}
                    >
                        ×
                    </CustomButton>
                </Modal.Header>

                <Modal.Body className="hashtag-modal-body">

                    {/* Coins */}
                    <Form.Group>
                        <Form.Label className="profile-pill">Country Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Country Name"
                            value={countryName}
                            onChange={(e) => setCountryName(e.target.value)}
                        />
                    </Form.Group>

                    {/* Active */}
                    <Form.Group>
                        <Form.Label className="profile-pill">Country Code</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Country Code"
                            value={currencyCode}
                            onChange={(e) => setCurrencyCode(e.target.value)}
                        />
                    </Form.Group>

                    {/* INR */}
                    <Form.Group>
                        <Form.Label className="profile-pill">Country Symbol</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Country Symbol"
                            value={currencySymbol}
                            onChange={(e) =>
                                setCurrencySymbol(e.target.value)
                            }
                        />
                    </Form.Group>

                    {/* USD */}
                    <Form.Group>
                        <Form.Label className="profile-pill">Status</Form.Label>
                        <Form.Select
                            value={isEnabled ? "true" : "false"}
                            onChange={(e) =>
                                setIsEnabled(e.target.value === "true")
                            }
                        >
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                        </Form.Select>
                    </Form.Group>

                </Modal.Body>

                <Modal.Footer className="hashtag-modal-footer">
                    <CustomButton
                        className="hashtag-close-footer-btn"
                        variant="secondary"
                        onClick={() => setShowModal(false)}
                    >
                        Cancel
                    </CustomButton>

                    <CustomButton
                        className="hashtag-save-btn"
                        variant="primary"
                        // onClick={handleAdd}
                        onClick={editId ? handleUpdate : handleAdd}
                    >
                        {/* Add */}
                        {editId ? "Update" : "Add"}
                    </CustomButton>
                </Modal.Footer>
            </Modal>

            <DeleteModal
                show={showDeleteModal}
                close={() => {
                    setShowDeleteModal(false);
                    setDeleteId(null);
                    setDeleteTag("");
                }}
                onDelete={handleDelete}
                title="Delete Currency"
                message="Are you sure you want to delete this Currency?"
                itemName={`${deleteTag}`}
            />
        </div>
    );
}